import { getApplicationSettings } from '~/cynqueModules/getApplicationSettings'

/**
 * Exposes the app settings to templates as `$getApplicationSettings`.
 *
 * The values themselves live in cynqueModules/getApplicationSettings.ts and this
 * plugin only delegates — the same split already used by the formatter plugins.
 * Non-component callers (the input-field spec modules) import that function
 * directly instead of going through this provide, because Nuxt 4 removed the
 * `window.$nuxt` global they previously reached it by.
 */
export default defineNuxtPlugin(() => {
  return { provide: { getApplicationSettings } }
})

export type { IApplicationSettings } from '~/cynqueModules/getApplicationSettings'
